import { SurfaceTypesEnum } from '../Standard/Enum/SurfaceTypesEnum'
import { IFrame } from "./Model/IFrame"
import { StandardShelfCalculator } from './../Standard';
import { ILongeron } from './Model/ILongeron';

export class AprodShelfCalculator extends StandardShelfCalculator {
  // Hossztartók  
  private longerons: ILongeron[] = [];
  // Keretek
  private frames: IFrame[] = [];
  // Kapocs
  private clipPrice: number = 0;

  constructor(props) {
    super(props);

    this.type = "aprod";
    this.name = "APROD polcrendszer tervező";
    this.previewImage = "/images/content/preview/aprod.jpg";

    this.surfaces = [SurfaceTypesEnum.Festett, SurfaceTypesEnum.Horganyzott];
    this.shelfsNumber = [4, 5, 6, 7];
    this.fieldsNumber = [1, 2, 3, 4];

    this.shelfs = [
      { width: 1200, depth: 800, price: [{ surface: SurfaceTypesEnum.Festett, price: 15040}, { surface: SurfaceTypesEnum.Horganyzott, price: 10720 }] },
      { width: 1200, depth: 700, price: [{ surface: SurfaceTypesEnum.Festett, price: 14120}, { surface: SurfaceTypesEnum.Horganyzott, price: 10050 }] },
      { width: 1200, depth: 600, price: [{ surface: SurfaceTypesEnum.Festett, price: 12320}, { surface: SurfaceTypesEnum.Horganyzott, price: 8780 }] },
      { width: 1200, depth: 500, price: [{ surface: SurfaceTypesEnum.Festett, price: 10810}, { surface: SurfaceTypesEnum.Horganyzott, price: 7710 }] },
      { width: 1200, depth: 400, price: [{ surface: SurfaceTypesEnum.Festett, price: 9620}, { surface: SurfaceTypesEnum.Horganyzott, price: 6840 }] },
      { width: 1200, depth: 300, price: [{ surface: SurfaceTypesEnum.Festett, price: 8060}, { surface: SurfaceTypesEnum.Horganyzott, price: 5740 }] },
      { width: 1000, depth: 800, price: [{ surface: SurfaceTypesEnum.Festett, price: 12160}, { surface: SurfaceTypesEnum.Horganyzott, price: 8660 }] },
      { width: 1000, depth: 700, price: [{ surface: SurfaceTypesEnum.Festett, price: 10510}, { surface: SurfaceTypesEnum.Horganyzott, price: 7480 }] },
      { width: 1000, depth: 600, price: [{ surface: SurfaceTypesEnum.Festett, price: 9510}, { surface: SurfaceTypesEnum.Horganyzott, price: 6780 }] },
      { width: 1000, depth: 500, price: [{ surface: SurfaceTypesEnum.Festett, price: 8090}, { surface: SurfaceTypesEnum.Horganyzott, price: 5760 }] },
      { width: 1000, depth: 400, price: [{ surface: SurfaceTypesEnum.Festett, price: 6620}, { surface: SurfaceTypesEnum.Horganyzott, price: 4710 }] },
      { width: 1000, depth: 300, price: [{ surface: SurfaceTypesEnum.Festett, price: 5240}, { surface: SurfaceTypesEnum.Horganyzott, price: 3740 }] },
      { width: 800, depth: 800, price: [{ surface: SurfaceTypesEnum.Festett, price: 11720}, { surface: SurfaceTypesEnum.Horganyzott, price: 8350 }] },
      { width: 800, depth: 700, price: [{ surface: SurfaceTypesEnum.Festett, price: 9510}, { surface: SurfaceTypesEnum.Horganyzott, price: 6780 }] },
      { width: 800, depth: 600, price: [{ surface: SurfaceTypesEnum.Festett, price: 8690}, { surface: SurfaceTypesEnum.Horganyzott, price: 6180 }] },
      { width: 800, depth: 500, price: [{ surface: SurfaceTypesEnum.Festett, price: 7260}, { surface: SurfaceTypesEnum.Horganyzott, price: 5180 }] },
      { width: 800, depth: 400, price: [{ surface: SurfaceTypesEnum.Festett, price: 6030}, { surface: SurfaceTypesEnum.Horganyzott, price: 4290 }] },
      { width: 800, depth: 300, price: [{ surface: SurfaceTypesEnum.Festett, price: 4740}, { surface: SurfaceTypesEnum.Horganyzott, price: 3380 }] },
      { width: 600, depth: 600, price: [{ surface: SurfaceTypesEnum.Festett, price: 7460}, { surface: SurfaceTypesEnum.Horganyzott, price: 5310 }] },
      { width: 600, depth: 500, price: [{ surface: SurfaceTypesEnum.Festett, price: 6230}, { surface: SurfaceTypesEnum.Horganyzott, price: 4430 }] },
      { width: 600, depth: 400, price: [{ surface: SurfaceTypesEnum.Festett, price: 5190}, { surface: SurfaceTypesEnum.Horganyzott, price: 3710 }] },
      { width: 600, depth: 300, price: [{ surface: SurfaceTypesEnum.Festett, price: 4170}, { surface: SurfaceTypesEnum.Horganyzott, price: 2960 }] }
    ];

    this.longerons = [
      { width: 1200, securityClip: 42, price: [{ surface: SurfaceTypesEnum.Festett, price: 3300}, { surface: SurfaceTypesEnum.Horganyzott, price: 2340}] },
      { width: 1000, securityClip: 42, price: [{ surface: SurfaceTypesEnum.Festett, price: 2970}, { surface: SurfaceTypesEnum.Horganyzott, price: 2120}] }, 
      { width: 800, securityClip: 42, price: [{ surface: SurfaceTypesEnum.Festett, price: 2850}, { surface: SurfaceTypesEnum.Horganyzott, price: 2030}] },
      { width: 600, securityClip: 42, price: [{ surface: SurfaceTypesEnum.Festett, price: 2720}, { surface: SurfaceTypesEnum.Horganyzott, price: 1950}] }
    ];

    this.frames = [{
      height: 2500, depth: 800, closingPlugPrice: 50, price: [{ surface: SurfaceTypesEnum.Festett, price: 23100}, { surface: SurfaceTypesEnum.Horganyzott, price: 16460 }]}, {
      height: 2500, depth: 700, closingPlugPrice: 50, price: [{ surface: SurfaceTypesEnum.Festett, price: 22160}, { surface: SurfaceTypesEnum.Horganyzott, price: 15800 }]}, {
      height: 2500, depth: 600, closingPlugPrice: 50, price: [{ surface: SurfaceTypesEnum.Festett, price: 21170}, { surface: SurfaceTypesEnum.Horganyzott, price: 15090 }]}, {
      height: 2500, depth: 500, closingPlugPrice: 50, price: [{ surface: SurfaceTypesEnum.Festett, price: 20330}, { surface: SurfaceTypesEnum.Horganyzott, price: 14480 }]}, {
      height: 2500, depth: 400, closingPlugPrice: 50, price: [{ surface: SurfaceTypesEnum.Festett, price: 19820}, { surface: SurfaceTypesEnum.Horganyzott, price: 14120 }]}, {
      height: 2500, depth: 300, closingPlugPrice: 50, price: [{ surface: SurfaceTypesEnum.Festett, price: 19080}, { surface: SurfaceTypesEnum.Horganyzott, price: 13590 }]}, {
      height: 2000, depth: 800, closingPlugPrice: 50, price: [{ surface: SurfaceTypesEnum.Festett, price: 18480}, { surface: SurfaceTypesEnum.Horganyzott, price: 13160 }]}, {
      height: 2000, depth: 700, closingPlugPrice: 50, price: [{ surface: SurfaceTypesEnum.Festett, price: 17550}, { surface: SurfaceTypesEnum.Horganyzott, price: 12500 }]}, {
      height: 2000, depth: 600, closingPlugPrice: 50, price: [{ surface: SurfaceTypesEnum.Festett, price: 16750}, { surface: SurfaceTypesEnum.Horganyzott, price: 11940 }]}, {
      height: 2000, depth: 500, closingPlugPrice: 50, price: [{ surface: SurfaceTypesEnum.Festett, price: 15880}, { surface: SurfaceTypesEnum.Horganyzott, price: 11310 }]}, {
      height: 2000, depth: 400, closingPlugPrice: 50, price: [{ surface: SurfaceTypesEnum.Festett, price: 15180}, { surface: SurfaceTypesEnum.Horganyzott, price: 10810 }]}, {
      height: 2000, depth: 300, closingPlugPrice: 50, price: [{ surface: SurfaceTypesEnum.Festett, price: 14760}, { surface: SurfaceTypesEnum.Horganyzott, price: 10510 }]}
    ];

    this.clipPrice = 174;
    this.multiplier = 1;

    this.init();

    let heights: number[] = [];
    for (let i = 0; i < this.frames.length; i++) {
      heights.push(this.frames[i].height);
    }
    this.setHeights(heights);
  }

  calculatePrice() {
    this.logger.log("calculatePrice AprodShelfCalculator");

    let system = this.getSystem();
    let depth = system.depth;
    let surface = system.surface;
    let height = system.height;

    let framePrice = this.frames.find(current => current.depth === depth && current.height === height)!.price
      .find(current => current.surface === surface)!.price;
    this.logger.log("Keret:", framePrice);
    let framesNumber = system.fieldsNumber;
    framesNumber++;
    let framesTotalPrice = framePrice * framesNumber;

    let closingPlugPrice = this.frames.find(current => current.depth === depth && current.height === height)!.closingPlugPrice;
    let closingPlugNumber = framesNumber * 2;
    let closingPlugTotalPrice = closingPlugNumber * closingPlugPrice;

    let longeronNumber = height <= 2000 ? 4 : 6;
    let securityClipsNumber = longeronNumber * 2;
    let shelfsTotalPrice = 0;
    let longeronTotalPrice = 0;
    let securityClipsTotalPrice = 0;

    for (let i = 0; i < system.fieldsNumber; i++) {
      let shelfValue = this.shelfs
        .find(current => current.depth === depth && current.width === system.shelfsWidth[i])!.price
        .find(current => current.surface === surface)!.price;
      let longeronPrice = this.longerons
        .find(current => current.width === system.shelfsWidth[i])!.price
        .find(current => current.surface === surface)!.price;

      let securityClipPrice = this.longerons
        .find(current => current.width === system.shelfsWidth[i])!.securityClip;

      shelfsTotalPrice += system.shelfsNumber * shelfValue;
      longeronTotalPrice += longeronNumber * longeronPrice;
      securityClipsTotalPrice += securityClipsNumber * securityClipPrice;
    }

    let clipNumber = ((system.shelfsNumber  - 2 )* system.fieldsNumber) * 4;
    let clipsTotalPrice = clipNumber * this.clipPrice;

    this.logger.log("Polcok:",  system.shelfsNumber, shelfsTotalPrice);
    this.logger.log("Hossztartók:", longeronTotalPrice);
    this.logger.log("Polctartó kapcsok:", clipNumber, clipsTotalPrice);
    this.logger.log("Biztonsági kapcsok:", securityClipsTotalPrice);
    this.logger.log("Keretek:", framesTotalPrice);
    this.logger.log("Záródugók:", closingPlugTotalPrice);

    let systemPrice = shelfsTotalPrice + longeronTotalPrice + clipsTotalPrice + securityClipsTotalPrice + framesTotalPrice + closingPlugTotalPrice;

    systemPrice *= this.multiplier;
    this.setState({
      netPrice: systemPrice,
      grossPrice: systemPrice * 1.27
    })
  }
}

export default AprodShelfCalculator;